import removeAccents from 'remove-accents';

export const createSlug = (text: string) => {
  if (!text) {
    return '';
  }

  return removeAccents(text)
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // strip forbidden characters (apostrophes, &, etc.)
    .replace(/[\s-]+/g, '-') // collapse runs of spaces/hyphens into a single hyphen
    .replace(/^-+|-+$/g, ''); // trim hyphens at both ends
};
